import plannerService from '@/http/services/planner'
export default {
  getDriverPlanner ({ commit }, driverId) {
    return plannerService.getDriverPlanner(driverId).then((planner) => {
      commit('setDriverPlanner',  planner.data)
    })
  },
  updateDriverPlanner ({ commit }, data) {
    return plannerService.updateDriverPlanner(data).then((planner) => {
      return planner
    })
  },
  removeBreak ({ commit }, data) {
    return plannerService.removeBreak(data).then((planner) => {
      return planner
    })
  },
  removeDayOff ({ commit }, data) {
    return plannerService.removeDayOff(data).then((planner) => {
      return planner
    })
  }
}
